<script>  
	import Aicon from './Aicon.svelte';
/* 	import { time } from './js/store.js';

const formatter = new Intl.DateTimeFormat('id', {
	hour12: false,
	hour: 'numeric',
	minute: '2-digit',
	second: '2-digit'
}); */
import { notif } from "./js/notif.js"; 

  let notify = {
	  tagihan:"",
	  shoping:"",
	  ship_job:"",
	  jualan:""
  };
  notif.subscribe((value) => {
	notify = value; 
  }); 

</script>
<div class="w-full gap-2 -mt-10 lg:flex">
	<div class="w-full mt-0 lg:mt-5 md:mt-2 lg:w-2/5"><div class="relative mx-0 -mt-16 bg-white rounded-lg shadow-lg lg:block lg:-mt-20 md:-mt-16 "><div class="flex flex-no-wrap pb-4 mx-auto my-0 items-justify lg:flex-wrap">
		<Aicon lg="w-2/6" md="w-1/6" xs="w-2/4" css="bg-transparent" text="Belanja" href="/belanja">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<rect x="5" y="19" fill="#CFD8DC" width="38" height="19" />
				<rect x="5" y="38" fill="#B0BEC5" width="38" height="4" />
				<rect x="27" y="24" fill="#455A64" width="12" height="18" />
				<rect x="9" y="24" fill="#E3F2FD" width="14" height="11" />
				<rect x="10" y="25" fill="#1E88E5" width="12" height="9" />
				<path fill="#90A4AE"
					d="M36.5,33.5c-0.3,0-0.5,0.2-0.5,0.5v2c0,0.3,0.2,0.5,0.5,0.5S37,36.3,37,36v-2C37,33.7,36.8,33.5,36.5,33.5z" />
				<g fill="#558B2F">
					<circle cx="24" cy="19" r="3" />
					<circle cx="36" cy="19" r="3" />
					<circle cx="12" cy="19" r="3" />
				</g>
				<path fill="#7CB342" d="M40,6H8C6.9,6,6,6.9,6,8v3h36V8C42,6.9,41.1,6,40,6z" />
				<rect x="21" y="11" fill="#7CB342" width="6" height="8" />
				<polygon fill="#7CB342" points="37,11 32,11 33,19 39,19" />
				<polygon fill="#7CB342" points="11,11 16,11 15,19 9,19" />
				<g fill="#FFA000">
					<circle cx="30" cy="19" r="3" />
					<path d="M45,19c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3L45,19z" />
					<circle cx="18" cy="19" r="3" />
					<path d="M3,19c0,1.7,1.3,3,3,3s3-1.3,3-3s-1.3-3-3-3L3,19z" />
				</g>
				<g fill="#FFC107">
					<polygon points="32,11 27,11 27,19 33,19" />
					<polygon points="42,11 37,11 39,19 45,19" />
					<polygon points="16,11 21,11 21,19 15,19" />
					<polygon points="6,11 11,11 9,19 3,19" />
				</g>
			</svg>
		</Aicon>
		<Aicon lg="w-2/6" md="w-1/6" xs="w-2/4"  css="shadow-xl bg-gray-200 -mt-4"text="Jualan" notif="{notify.jualan}" href="/tokoku/transaksi">				
		<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
		version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
			<path fill="#2E7D32" d="M25.4,5.6c-0.8-0.8-2-0.8-2.8,0l-12,12c-0.8,0.8-0.8,2,0,2.8C11,20.8,11.5,21,12,21s1-0.2,1.4-0.6l12-12 C26.2,7.6,26.2,6.4,25.4,5.6z"/>
			<path fill="#1B5E20" d="M37.4,17.6l-12-12c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8l12,12C35,20.8,35.5,21,36,21s1-0.2,1.4-0.6 C38.2,19.6,38.2,18.4,37.4,17.6z"/>
			<path fill="#388E3C" d="M37.4,41H10.6c-1,0-1.8-0.7-2-1.6L5,21h38l-3.7,18.4C39.1,40.3,38.3,41,37.4,41z"/>
			<path fill="#4CAF50" d="M43,23H5c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h38c1.1,0,2,0.9,2,2v2C45,22.1,44.1,23,43,23z"/>
			<polygon fill="#DCEDC8" points="30.8,24.8 22.9,32.7 19.2,28.9 17,31.1 22.9,37 33,26.9"/>
		</svg> 
		</Aicon>
		<Aicon lg="w-2/6" md="w-1/6" xs="w-2/4" css="bg-transparent" text="Ngirim" notif="{notify.ship_job}" href="/ngirim/all">				
		<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
		version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
			<circle fill="#FF9800" cx="28" cy="9" r="5"/>
			<path fill="#00796B" d="M29,27.3l-9.2-4.1c-1-0.5-1.5,1-2,2c-0.5,1-4.1,7.2-3.8,8.3c0.3,0.9,1.1,1.4,1.9,1.4c0.2,0,0.4,0,0.6-0.1 L28.8,31c0.8-0.2,1.4-1,1.4-1.8C30.2,28.4,29.7,27.6,29,27.3z"/>
			<path fill="#009688" d="M26.8,15.2l-2.2-1c-1.3-0.6-2.9,0-3.5,1.3L9.2,41.1c-0.5,1,0,2.2,1,2.7c0.3,0.1,0.6,0.2,0.9,0.2 c0.8,0,1.5-0.4,1.8-1.1c0,0,9.6-13.3,10.4-14.9s4.9-9.3,4.9-9.3C28.7,17.4,28.2,15.8,26.8,15.2z"/>
			<path fill="#FF9800" d="M40.5,15.7c-0.7-0.8-2-1-2.8-0.3l-5,4.2l-6.4-3.5c-1.1-0.6-2.6-0.4-3.3,0.9c-0.8,1.3-0.4,2.9,0.8,3.4 l8.3,3.4c0.3,0.1,0.6,0.2,0.9,0.2c0.5,0,0.9-0.2,1.3-0.5l6-5C41.1,17.8,41.2,16.6,40.5,15.7z"/>
			<path fill="#FF9800" d="M11.7,23.1l3.4-5.1l4.6,0.6l1.5-3.1c0.4-0.9,1.2-1.4,2.1-1.5c-0.1,0-0.2,0-0.2,0h-9c-0.7,0-1.3,0.3-1.7,0.9 l-4,6c-0.6,0.9-0.4,2.2,0.6,2.8C9.2,23.9,9.6,24,10,24C10.6,24,11.3,23.7,11.7,23.1z"/>
		</svg>
		</Aicon>
	
	</div>
	<div class="p-2 text-center border-t border-gray-300">Ayo Geliatkan UMKM Pedesaan<br>Mulai jualan di <b>dekatan</b></div>
	</div></div>
	
	<div class="w-full mt-5 lg:w-4/5 lg:mt-auto"><div class="relative p-2 mx-0 bg-gray-100 rounded-lg shadow lg:bg-white md:bg-gray-100 lg:block lg:shadow-lg"><div class="flex flex-no-wrap items-start pb-2 mx-auto my-1 overflow-x-auto justify-self-auto">
		
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="bg-transparent" text="Tagihan" notif="{notify.tagihan}" href="/tagihan">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<path fill="#78909C"
					d="M40,41H8c-2.2,0-4-1.8-4-4l0-20.9c0-1.3,0.6-2.5,1.7-3.3L24,0l18.3,12.8c1.1,0.7,1.7,2,1.7,3.3V37 C44,39.2,42.2,41,40,41z">
				</path>
				<rect x="14" y="1" fill="#AED581" width="20" height="31"></rect>
				<g fill="#558B2F">
					<path d="M13,0v33h22V0H13z M33,31H15V2h18V31z"></path>
					<path d="M34,3c0,1.7-0.3,3-2,3c-1.7,0-3-1.3-3-3s1.3-2,3-2C33.7,1,34,1.3,34,3z"></path>
					<path d="M16,1c1.7,0,3,0.3,3,2s-1.3,3-3,3s-2-1.3-2-3S14.3,1,16,1z"></path>
					<circle cx="24" cy="8" r="2"></circle>
					<circle cx="24" cy="20" r="6"></circle>
				</g>
				<path fill="#CFD8DC" d="M40,41H8c-2.2,0-4-1.8-4-4l0-20l20,13l20-13v20C44,39.2,42.2,41,40,41z">
				</path>
			</svg>
		</Aicon>
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="bg-transparent" text="Transaksi" notif="{notify.shoping}" href="/akun/transaksi">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48"><polygon fill="#90CAF9" points="33,42 5,42 5,4 24,4 33,13"/>
				<polygon fill="#E1F5FE" points="31.5,14 23,14 23,5.5"/>
				<rect x="38.3" y="34.8" transform="matrix(.707 -.707 .707 .707 -17.177 40.055)" fill="#616161" width="2.8" height="12"/>
				<circle fill="#616161" cx="28" cy="29" r="11"/>
				<circle fill="#90CAF9" cx="28" cy="29" r="9"/>
				<rect x="39.5" y="37.6" transform="matrix(.707 -.707 .707 .707 -17.661 41.223)" fill="#37474F" width="2.8" height="8.7"/>
				<g fill="#1976D2">
					<path d="M30,31h-9.7c0.4,1.6,1.3,3,2.5,4H30V31z"/>
					<path d="M20.3,27H30v-4h-7.3C21.5,24,20.7,25.4,20.3,27z"/>
					<path d="M20.1,20H11v2h7.3C18.8,21.3,19.4,20.6,20.1,20z"/>
					<path d="M17.1,24H11v2h5.4C16.6,25.3,16.8,24.6,17.1,24z"/>
					<path d="M16,29c0-0.3,0-0.7,0.1-1H11v2h5.1C16,29.7,16,29.3,16,29z"/>
					<path d="M16.4,32H11v2h6.1C16.8,33.4,16.6,32.7,16.4,32z"/>
				</g>
			</svg>
		</Aicon>
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="bg-transparent" text="Hotspot" href="/hotspot">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<path fill="#E38939"
					d="M12,40V8c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z" />
				<path fill="#FFF3E0"
					d="M32,7H16c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8C33,7.4,32.6,7,32,7z" />
				<circle fill="#A6642A" cx="24" cy="41" r="1.5" />
				<circle fill="#E91E63" cx="24" cy="23" r="2" />
				<circle fill="none" stroke="#F48FB1" stroke-width="2" stroke-miterlimit="10" cx="24" cy="23"
					r="4" />
				<circle fill="none" stroke="#F8BBD0" stroke-miterlimit="10" cx="24" cy="23" r="6.5" />
			</svg>
		</Aicon>
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="bg-transparent" text="Poin" href="/points">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<g fill="#FFA000">
					<path
						d="M38,13c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,12.1,41.3,13,38,13 z" />
					<path
						d="M38,10c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,9.1,41.3,10,38,10z" />
					<path
						d="M38,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,15.1,41.3,16,38,16 z" />
					<path
						d="M38,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,18.1,41.3,19,38,19 z" />
					<path
						d="M38,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,21.1,41.3,22,38,22 z" />
					<path
						d="M38,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,24.1,41.3,25,38,25 z" />
					<path
						d="M38,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,27.1,41.3,28,38,28 z" />
					<path
						d="M38,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,30.1,41.3,31,38,31 z" />
					<path
						d="M38,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,33.1,41.3,34,38,34 z" />
					<path
						d="M38,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,36.1,41.3,37,38,37 z" />
					<path
						d="M38,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,39.1,41.3,40,38,40 z" />
				</g>
				<g fill="#FFC107">
					<ellipse cx="38" cy="8" rx="6" ry="2" />
					<path
						d="M38,12c-2.8,0-5.1-0.6-5.8-1.5C32.1,10.7,32,10.8,32,11c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,11.4,40.8,12,38,12z" />
					<path
						d="M38,15c-2.8,0-5.1-0.6-5.8-1.5C32.1,13.7,32,13.8,32,14c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,14.4,40.8,15,38,15z" />
					<path
						d="M38,18c-2.8,0-5.1-0.6-5.8-1.5C32.1,16.7,32,16.8,32,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,17.4,40.8,18,38,18z" />
					<path
						d="M38,21c-2.8,0-5.1-0.6-5.8-1.5C32.1,19.7,32,19.8,32,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,20.4,40.8,21,38,21z" />
					<path
						d="M38,24c-2.8,0-5.1-0.6-5.8-1.5C32.1,22.7,32,22.8,32,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,23.4,40.8,24,38,24z" />
					<path
						d="M38,27c-2.8,0-5.1-0.6-5.8-1.5C32.1,25.7,32,25.8,32,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,26.4,40.8,27,38,27z" />
					<path
						d="M38,30c-2.8,0-5.1-0.6-5.8-1.5C32.1,28.7,32,28.8,32,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,29.4,40.8,30,38,30z" />
					<path
						d="M38,33c-2.8,0-5.1-0.6-5.8-1.5C32.1,31.7,32,31.8,32,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,32.4,40.8,33,38,33z" />
					<path
						d="M38,36c-2.8,0-5.1-0.6-5.8-1.5C32.1,34.7,32,34.8,32,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,35.4,40.8,36,38,36z" />
					<path
						d="M38,39c-2.8,0-5.1-0.6-5.8-1.5C32.1,37.7,32,37.8,32,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,38.4,40.8,39,38,39z" />
				</g>
				<g fill="#FFA000">
					<path
						d="M10,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,18.1,13.3,19,10,19 z" />
					<path
						d="M10,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,15.1,13.3,16,10,16 z" />
					<path
						d="M10,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,21.1,13.3,22,10,22 z" />
					<path
						d="M10,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,24.1,13.3,25,10,25 z" />
					<path
						d="M10,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,27.1,13.3,28,10,28 z" />
					<path
						d="M10,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,30.1,13.3,31,10,31 z" />
					<path
						d="M10,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,33.1,13.3,34,10,34 z" />
					<path
						d="M10,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,36.1,13.3,37,10,37 z" />
					<path
						d="M10,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,39.1,13.3,40,10,40 z" />
				</g>
				<g fill="#FFC107">
					<ellipse cx="10" cy="14" rx="6" ry="2" />
					<path
						d="M10,18c-2.8,0-5.1-0.6-5.8-1.5C4.1,16.7,4,16.8,4,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,17.4,12.8,18,10,18z" />
					<path
						d="M10,21c-2.8,0-5.1-0.6-5.8-1.5C4.1,19.7,4,19.8,4,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,20.4,12.8,21,10,21z" />
					<path
						d="M10,24c-2.8,0-5.1-0.6-5.8-1.5C4.1,22.7,4,22.8,4,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,23.4,12.8,24,10,24z" />
					<path
						d="M10,27c-2.8,0-5.1-0.6-5.8-1.5C4.1,25.7,4,25.8,4,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,26.4,12.8,27,10,27z" />
					<path
						d="M10,30c-2.8,0-5.1-0.6-5.8-1.5C4.1,28.7,4,28.8,4,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,29.4,12.8,30,10,30z" />
					<path
						d="M10,33c-2.8,0-5.1-0.6-5.8-1.5C4.1,31.7,4,31.8,4,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,32.4,12.8,33,10,33z" />
					<path
						d="M10,36c-2.8,0-5.1-0.6-5.8-1.5C4.1,34.7,4,34.8,4,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,35.4,12.8,36,10,36z" />
					<path
						d="M10,39c-2.8,0-5.1-0.6-5.8-1.5C4.1,37.7,4,37.8,4,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,38.4,12.8,39,10,39z" />
				</g>
				<g fill="#FFA000">
					<path
						d="M24,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,27.1,27.3,28,24,28 z" />
					<path
						d="M24,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,24.1,27.3,25,24,25 z" />
					<path
						d="M24,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,30.1,27.3,31,24,31 z" />
					<path
						d="M24,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,33.1,27.3,34,24,34 z" />
					<path
						d="M24,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,36.1,27.3,37,24,37 z" />
					<path
						d="M24,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,39.1,27.3,40,24,40 z" />
				</g>
				<g fill="#FFC107">
					<ellipse cx="24" cy="23" rx="6" ry="2" />
					<path
						d="M24,27c-2.8,0-5.1-0.6-5.8-1.5C18.1,25.7,18,25.8,18,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,26.4,26.8,27,24,27z" />
					<path
						d="M24,30c-2.8,0-5.1-0.6-5.8-1.5C18.1,28.7,18,28.8,18,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,29.4,26.8,30,24,30z" />
					<path
						d="M24,33c-2.8,0-5.1-0.6-5.8-1.5C18.1,31.7,18,31.8,18,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,32.4,26.8,33,24,33z" />
					<path
						d="M24,36c-2.8,0-5.1-0.6-5.8-1.5C18.1,34.7,18,34.8,18,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,35.4,26.8,36,24,36z" />
					<path
						d="M24,39c-2.8,0-5.1-0.6-5.8-1.5C18.1,37.7,18,37.8,18,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,38.4,26.8,39,24,39z" />
				</g>
			</svg>
		</Aicon>
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="bg-transparent" text="Kabar" href="/kabar">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-0" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<path fill="#FF5722" d="M32,15v28H10c-2.2,0-4-1.8-4-4V15H32z" />
				<path fill="#FFCCBC" d="M14,5v34c0,2.2-1.8,4-4,4h29c2.2,0,4-1.8,4-4V5H14z" />
				<g fill="#FF5722">
					<rect x="20" y="10" width="18" height="4" />
					<rect x="20" y="17" width="8" height="2" />
					<rect x="30" y="17" width="8" height="2" />
					<rect x="20" y="21" width="8" height="2" />
					<rect x="30" y="21" width="8" height="2" />
					<rect x="20" y="25" width="8" height="2" />
					<rect x="30" y="25" width="8" height="2" />
					<rect x="20" y="29" width="8" height="2" />
					<rect x="30" y="29" width="8" height="2" />
					<rect x="20" y="33" width="8" height="2" />
					<rect x="30" y="33" width="8" height="2" />
					<rect x="20" y="37" width="8" height="2" />
					<rect x="30" y="37" width="8" height="2" />
				</g>
			</svg>
		</Aicon>
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="bg-transparent" text="Kartu" href="/kartu">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<path fill="#FF9800"
					d="M5,35V13c0-2.2,1.8-4,4-4h30c2.2,0,4,1.8,4,4v22c0,2.2-1.8,4-4,4H9C6.8,39,5,37.2,5,35z" />
				<g fill="#FFD54F">
					<path
						d="M43,21v-2H31c-1.1,0-2-0.9-2-2s0.9-2,2-2h1v-2h-1c-2.2,0-4,1.8-4,4s1.8,4,4,4h3v6h-3c-2.8,0-5,2.2-5,5 s2.2,5,5,5h2v-2h-2c-1.7,0-3-1.3-3-3s1.3-3,3-3h12v-2h-7v-6H43z" />
					<path
						d="M17,27h-3v-6h3c2.2,0,4-1.8,4-4s-1.8-4-4-4h-3v2h3c1.1,0,2,0.9,2,2s-0.9,2-2,2H5v2h7v6H5v2h12 c1.7,0,3,1.3,3,3s-1.3,3-3,3h-2v2h2c2.8,0,5-2.2,5-5S19.8,27,17,27z" />
				</g>
			</svg>
		</Aicon>
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="shadow-lg bg-gray-200" text="Pelayanan" href="/pelayanan">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<g fill="#FFA726">
					<circle cx="10" cy="26" r="4" />
					<circle cx="38" cy="26" r="4" />
				</g>
				<path fill="#FFB74D"
					d="M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z" />
				<path fill="#FF5722"
					d="M24,3C14.6,3,7,10.6,7,20c0,1.2,0,3.4,0,3.4L9,25v-3l21-9.8l9,9.8v3l2-1.6c0,0,0-2.1,0-3.4 C41,12,35.3,3,24,3z" />
				<g fill="#784719">
					<circle cx="31" cy="26" r="2" />
					<circle cx="17" cy="26" r="2" />
				</g>
				<path fill="#757575"
					d="M43,24c-0.6,0-1,0.4-1,1v-7c0-8.8-7.2-16-16-16h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h7c7.7,0,14,6.3,14,14v10 c0,0.6,0.4,1,1,1s1-0.4,1-1v2c0,3.9-3.1,7-7,7H24c-0.6,0-1,0.4-1,1s0.4,1,1,1h11c5,0,9-4,9-9v-5C44,24.4,43.6,24,43,24z" />
				<g fill="#37474F">
					<path
						d="M43,22h-1c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-4C45,22.9,44.1,22,43,22z" />
					<circle cx="24" cy="38" r="2" />
				</g>
			</svg>
		</Aicon>
		<Aicon lg="w-2/12" md="w-1/6" xs="w-1/4" css="bg-transparent" text="Riwayat" href="/riwayat">
			<svg class="inline-block w-12 h-12 text-gray-800 stroke-current" xmlns="http://www.w3.org/2000/svg"
				version="1" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
				<circle fill="#00ACC1" cx="24" cy="24" r="20"/>
				<circle fill="#eee" cx="24" cy="24" r="16"/>
				<rect x="23" y="11" width="2" height="13"/>
				<rect x="26.1" y="22.7" transform="matrix(-.707 .707 -.707 -.707 65.787 27.25)" width="2.3" height="9.2"/>
				<circle cx="24" cy="24" r="2"/>
				<circle fill="#00ACC1" cx="24" cy="24" r="1"/>
			</svg>
		</Aicon>
	</div></div></div>
	</div>
 